export function StatusBadge({ status, label }) {
  const s = (status || "").toLowerCase();
  const map = {
    valid: { c: "#00FF66", bg: "rgba(0,255,102,0.1)", b: "rgba(0,255,102,0.3)" },
    active: { c: "#00FF66", bg: "rgba(0,255,102,0.1)", b: "rgba(0,255,102,0.3)" },
    provider_accepted: { c: "#00FF66", bg: "rgba(0,255,102,0.1)", b: "rgba(0,255,102,0.3)" },
    running: { c: "#E1FF00", bg: "rgba(225,255,0,0.1)", b: "rgba(225,255,0,0.35)" },
    sending: { c: "#E1FF00", bg: "rgba(225,255,0,0.1)", b: "rgba(225,255,0,0.35)" },
    pending: { c: "#8E8E93", bg: "rgba(142,142,147,0.1)", b: "rgba(142,142,147,0.3)" },
    not_tested: { c: "#8E8E93", bg: "rgba(142,142,147,0.1)", b: "rgba(142,142,147,0.3)" },
    paused: { c: "#FF9500", bg: "rgba(255,149,0,0.1)", b: "rgba(255,149,0,0.3)" },
    stopped: { c: "#FF9500", bg: "rgba(255,149,0,0.1)", b: "rgba(255,149,0,0.3)" },
    completed: { c: "#00E5FF", bg: "rgba(0,229,255,0.1)", b: "rgba(0,229,255,0.3)" },
    draft: { c: "#8E8E93", bg: "rgba(142,142,147,0.1)", b: "rgba(142,142,147,0.3)" },
    proxy_failure: { c: "#FF3B30", bg: "rgba(255,59,48,0.1)", b: "rgba(255,59,48,0.3)" },
    connection_failed: { c: "#FF3B30", bg: "rgba(255,59,48,0.1)", b: "rgba(255,59,48,0.3)" },
    invalid_credentials: { c: "#FF3B30", bg: "rgba(255,59,48,0.1)", b: "rgba(255,59,48,0.3)" },
    timeout: { c: "#FF3B30", bg: "rgba(255,59,48,0.1)", b: "rgba(255,59,48,0.3)" },
    ip_mismatch: { c: "#FF3B30", bg: "rgba(255,59,48,0.1)", b: "rgba(255,59,48,0.3)" },
    failed: { c: "#FF3B30", bg: "rgba(255,59,48,0.1)", b: "rgba(255,59,48,0.3)" },
    authentication_error: { c: "#FF3B30", bg: "rgba(255,59,48,0.1)", b: "rgba(255,59,48,0.3)" },
    missing_configuration: { c: "#FF9500", bg: "rgba(255,149,0,0.1)", b: "rgba(255,149,0,0.3)" },
    skipped: { c: "#8E8E93", bg: "rgba(142,142,147,0.1)", b: "rgba(142,142,147,0.3)" },
  };
  const style = map[s] || { c: "#A1A1AA", bg: "rgba(255,255,255,0.05)", b: "rgba(255,255,255,0.1)" };
  return (
    <span
      className="inline-flex items-center px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider"
      style={{
        color: style.c,
        backgroundColor: style.bg,
        border: `1px solid ${style.b}`,
        borderRadius: 2,
      }}
      data-testid={`badge-${s}`}
    >
      {label || s.replace(/_/g, " ")}
    </span>
  );
}
